export default {
  buildNumber: '{Build.BuildNumber}',
  commit: '{Build.SourceVersion}',
}
